import $http from '../../../axios-intance';
import {MessageBox, Notification} from 'element-ui';

export async function findAll({commit, state, dispatch}, reset_page = false) {

    if (reset_page) {
        commit('resetPageFilters');
    }

    const user_b2b = JSON.parse(localStorage.getItem('user_b2b'));

    commit('setContactWarehouseIdRequestGuaranteeFilters', user_b2b.id);
    commit('setPreloader', true);

    await $http.get('/api/solicitud-de-garantia', {params: state.filters})
        .then((response) => {
            commit('setRequestsGuarantees', response.data.data);
            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error',
                message: 'Error al obtener las solicitudes de garantía',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function create({commit, state, dispatch}, files) {

    return new Promise(async (resolve, reject) => {

        commit('setSending', true);
        commit('setPreloader', true);

        let form_data = new FormData();

        const user_b2b = JSON.parse(localStorage.getItem('user_b2b'));

        commit('setContactWarehouseIdRequestGuarantee', user_b2b.id);

        for (const property in state.request_guarantee) {
            if (property !== 'request_guarantee_products') {
                form_data.append(property, state.request_guarantee[property]);
            }
        }

        let keys = [
            'images_product',
            'other_images',
            'images_guide'
        ];

        keys.map(key => {
            for (let i = 0; i < files[key].length; i++) {
                form_data.append(key + '_loaded[' + i + ']', files[key][i]);
            }
        });

        await $http.post('/api/solicitud-de-garantia', form_data)
            .then(async (response) => {
                await dispatch('findAll');
                commit('setModalShow', false);
                commit('resetRequestGuarantee');
                commit('setSending', false);
                commit('setPreloader', false);

                Notification.success({
                    title: 'Éxito!',
                    message: 'Solicitud de garantía creada correctamente',
                    type: 'success',
                    duration: 3000,
                    customClass: 'notification-box',
                });
            }).catch((error) => {
                commit('setSending', false);
                commit('setPreloader', false);

                Notification.error({
                    title: 'Error',
                    message: 'Error al crear la solicitud de garantía',
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });
            });
    });
}

export async function update({commit, state, dispatch}, files) {

    return new Promise(async (resolve, reject) => {

        commit('setSending', true);
        commit('setPreloader', true);

        let form_data = new FormData();

        const user_b2b = JSON.parse(localStorage.getItem('user_b2b'));

        commit('setContactWarehouseIdRequestGuarantee', user_b2b.id);

        for (const property in state.request_guarantee) {
            if (property !== 'attachments_deleted' && property !== 'request_guarantee_products') {
                form_data.append(property, state.request_guarantee[property]);
            }
        }

        let keys = [
            'images_product',
            'other_images',
            'images_guide'
        ];

        keys.map(key => {
            for (let i = 0; i < files[key].length; i++) {
                form_data.append(key + '_loaded[' + i + ']', files[key][i]);
            }
        });


        for (let i = 0; i < state.request_guarantee.attachments_deleted.length; i++) {
            form_data.append('attachments_deleted[' + i + ']', state.request_guarantee.attachments_deleted[i].id);
        }

        await $http.post('/api/solicitud-de-garantia/' + state.request_guarantee.id, form_data)
            .then((response) => {
                dispatch('findAll');
                commit('setModalShow', false);
                commit('resetRequestGuarantee');
                commit('setSending', false);
                commit('setPreloader', false);

                Notification.success({
                    title: 'Éxito!',
                    message: 'Solicitud de garantía creada correctamente',
                    type: 'success',
                    duration: 3000,
                    customClass: 'notification-box',
                });
            }).catch((error) => {
                commit('setSending', false);
                commit('setPreloader', false);

                Notification.error({
                    title: 'Error',
                    message: 'Error al crear la solicitud de garantía',
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });
            });
    });
}

export async function findForId({commit, state, dispatch}, id) {

    commit('setPreloader', true);

    await $http.get('/api/solicitud-de-garantia/' + id)
        .then((response) => {
            commit('setRequestGuarantee', response.data.data);

            let step = 1;
            let action = 'Editar';

            if (state.request_guarantee.request_guarantee_state && state.request_guarantee.request_guarantee_state.state) {
                let step_code = state.request_guarantee.request_guarantee_state.state.code_parameter;

                let step_obj = state.steps.find(s => s.code === step_code);

                if (step_obj) {
                    step = step_obj.step;
                }

                if (step > 1) {
                    action = 'Ver';
                }

                if (step_code === 'PGS4') {
                    action = 'Recibir';
                    step++;
                }

                if (step_code === 'PGS9') {
                    action = 'Ver';
                }
            }

            commit('setStep', step);
            commit('setAction', action);
            commit('setStepAvailable', step);
            commit('setPreloader', false);

        }).catch((error) => {

            commit('setPreloader', false);

            Notification.error({
                title: 'Error',
                message: 'Error al obtener la solicitud de garantía',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function updateWithNewState({commit, state, dispatch}, files) {
    commit('setSending', true);
    commit('setPreloader', true);

    let form_data = new FormData();

    for (const property in state.request_guarantee) {
        if (property !== 'attachments_deleted') {
            form_data.append(property, state.request_guarantee[property]);
        }
    }

    let keys = [
        'images_evaluation',
        'images_guide_send',
        'images_delivery_customer'
    ];

    keys.map(key => {
        if (files[key]) {
            for (let i = 0; i < files[key].length; i++) {
                form_data.append(key + '_loaded[' + i + ']', files[key][i]);
            }
        }
    });

    for (let i = 0; i < state.request_guarantee.attachments_deleted.length; i++) {
        form_data.append('attachments_deleted[' + i + ']', state.request_guarantee.attachments_deleted[i].id);
    }

    await $http.post('/api/solicitud-de-garantia/nuevo-estado/' + state.request_guarantee.id, form_data)
        .then(async (response) => {
            await dispatch('findAll');
            commit('setModalShow', false);
            commit('resetRequestGuarantee');
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.success({
                title: 'Éxito!',
                message: 'Solicitud de garantía actualizada correctamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
        }).catch((error) => {
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.error({
                title: 'Error',
                message: 'Error al actualizar la solicitud de garantía',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function deleteAttachment({commit, state}, attachment) {
    await MessageBox.confirm('¿Está seguro de eliminar el adjunto?', 'Eliminar adjunto', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        customClass: 'notification-danger'
    }).then(async (result) => {
        commit('addAttachmentDeleteRequestGuarantee', attachment);
        commit('deleteAttachmentRequestGuarantee', attachment);
    }).catch((e) => {
        console.error(e);
    });
}

export async function destroy({commit, state, dispatch}, request_guarantee) {

    if (!request_guarantee.only_view) {
        await MessageBox.confirm('¿Está seguro de cancelar la solicitud de garantía?', 'Cancelar', {
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            type: 'warning',
            customClass: 'notification-danger'
        }).then(async (result) => {

            commit('setPreloader', true);

            await $http.delete('/api/solicitud-de-garantia/' + request_guarantee.id)
                .then(async (response) => {
                    await dispatch('findAll');
                    commit('setPreloader', false);
                    Notification.success({
                        title: 'Éxito!',
                        message: 'Solicitud de garantía cancelada correctamente',
                        type: 'success',
                        duration: 3000,
                        customClass: 'notification-box',
                    });
                }).catch((error) => {
                    Notification.error({
                        title: 'Error',
                        message: 'Error al cancelar la solicitud de garantía',
                        type: 'error',
                        duration: 3000,
                        customClass: 'notification-box',
                    });
                });
        }).catch((e) => {
            commit('setPreloader', false);
            console.error(e);
        });
    }
}

export async function downloadAttachment({commit}, attachment) {

    commit('setPreloader', true);

    await $http({
        url: '/api/solicitud-de-garantia/descargar-adjunto/' + attachment.id,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {

        commit('setPreloader', false);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', attachment.original_name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {

        commit('setPreloader', false);
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    });
}
